import React from "react";

function WorkCard(props) {
  return (
    <>
      <div className="work-card text-center">
        <h3>{props.title}</h3>
        <p>{props.description}</p>
        <div>
          <a href={props.figmaLink} rel="noreferrer" target="_blank">
            Clickable Prototype
          </a>
          <a href={props.csLink} rel="noreferrer" target="_blank">
            Case Study
          </a>
        </div>
        <img src={props.image} alt={props.title} />
      </div>
    </>
  );
}

export default WorkCard;
